function checkIfFirstCharIsAlphabetic(word: string) {
  return /^[A-Za-z]/gi.test(word);
}

const getLastInitial = (names: Array<string>): string => {
  if (names && !checkIfFirstCharIsAlphabetic(names[names.length - 1])) {
    const shorterList = names.slice(0, names.length - 1) ?? [''];
    return getLastInitial(shorterList);
  } else {
    if (names?.length === 1) return names[0].charAt(0);
    return names?.length > 1 ? names[names.length - 1].charAt(0) : '';
  }
};

const getFirstInitial = (names: Array<string>): string => {
  if (!names) return '';
  if (names && !checkIfFirstCharIsAlphabetic(names[0])) {
    const shorterList = names.slice(1, names.length) ?? [''];
    return getFirstInitial(shorterList);
  } else {
    if (names?.length === 1) return '';
    const alphabeticWords = names?.filter(checkIfFirstCharIsAlphabetic) ?? [''];
    if (alphabeticWords.length === 1) return ''; //last name initial is to be considered
    return names?.length > 1 ? names[0].charAt(0) : '';
  }
};

/**
 * @param displayName: A variable that should be provided by the BE, or a combination of firstName and lastName
 * @returns The initials of the displayName (if available), or an empty string
 */

function getAvatarInitials(displayName: string) {
  if (/^[A-Z0-9+_.-]+@[A-Z0-9.-]+$/gi.test(displayName)) return ''; //if displayName is an email return empty string
  if (!displayName) return '';
  if (displayName === 'Unknown Contact' || displayName === 'Unknown') return '';
  const displayNameWithoutAsterisk = displayName.replace(/\*/g, '1');
  const names = displayNameWithoutAsterisk?.split(' ');
  const lastChar = getLastInitial(names);

  const alphabeticWords = names.filter(checkIfFirstCharIsAlphabetic);
  //if displayName has no alphabets ( i.e has only numbers or special characters) then return empty string
  if (alphabeticWords.length === 0) return '';
  const firstChar = getFirstInitial(names);

  return `${firstChar}${lastChar}`.toUpperCase();
}

export { getAvatarInitials, getFirstInitial, getLastInitial };
